module.exports = __webpack_public_path__ + "static/img/exe.b36ffdf3.png";